<template>
  <div>
    <v-dialog persistent :value="addModal" width="700">
      <v-card>
        <loading-block class="pt-8" v-if="!loaded"></loading-block>
        <div v-else>
          <v-card-title>{{'Create a new location product ' + (form.allergen ? form.allergen : '')}}</v-card-title>
          <v-card-text>
            <!-- if type is blank show 2 options -->
            <div v-if="type == ''">
              <v-btn
                color="primary"
                class="ma-2 white--text"
                @click.prevent="type = 'master'"
              >COPY FROM PRODUCT BANK</v-btn>
              <v-btn
                color="primary"
                class="ma-2 white--text"
                @click.prevent="syncPosPriceAndQty()"
              >SYNC POS PRICE AND QTY</v-btn>
              <v-btn
                color="primary"
                class="ma-2 white--text"
                @click.prevent="type = 'new'"
              >CREATE NEW PRODUCT</v-btn>
            </div>

            <!-- Existing mater product list -->
            <template v-if="type == 'master'">
              <div class="text-left my-5">
                <v-btn fab small dark color="primary" depressed @click.prevent="backToAddOption()">
                  <v-icon dark>fas fa-arrow-left</v-icon>
                </v-btn>
              </div>

              <v-data-table
                class="py-3 pb-5 tabulardata"
                :headers="headers"
                :items="masterProductWithCategoryAppended"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
              >
                <template v-slot:[`item.thumbnail`]="{ item }">
                  <div class="inline-logo-name limited-img-height">
                    <img
                      v-if="item.image"
                      :src="item.image"
                      style="width:auto; height:auto; max-height:90px; max-width:90px;"
                      :alt="item.name"
                    />
                    <span style="margin-left:5px;">{{ item.name }}</span>
                  </div>
                </template>
                <template v-slot:[`item.category`]="{ item }">
                  <v-select v-model="item.category" :items="selectableCategories"></v-select>
                </template>
                <template v-slot:[`item.action`]="{ item }" width="200px">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <a v-on:click.prevent="addFromMasterProduct(item)">
                        <v-btn v-on="on" fab small dark color="primary" depressed>
                          <v-icon dark>fas fa-arrow-right</v-icon>
                        </v-btn>
                      </a>
                    </template>
                    <span>Clone Now</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <p class="mb-0">No data.</p>
                </template>
              </v-data-table>
            </template>

            <v-form ref="addForm" lazy-validation v-if="type == 'new'">
              <div class="text-left my-5">
                <v-btn fab small dark color="primary" depressed @click.prevent="backToAddOption()">
                  <v-icon dark>fas fa-arrow-left</v-icon>
                </v-btn>
              </div>
              <v-layout wrap justify-space-between>
                <v-flex xs12 sm12 md6 :class="$vuetify.breakpoint.width > 960 ? 'pr-3' : ''">
                  <v-autocomplete
                    v-model="form.brand_id"
                    :items="selectableBrands"
                    item-text="text"
                    item-value="value"
                    label="Brand name"
                    :rules="normalValidation"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="form.category_id"
                    :items="selectableCategories"
                    label="Category"
                    item-text="text"
                    item-value="value"
                    :rules="normalValidation"
                  >
                    <template slot="item" slot-scope="data">
                      <span v-if="data.item.parent===null" style="font-weight: bold; margin-left:10px;">{{ data.item.text }}</span>
                      <span v-else style="margin-left:30px;">{{ data.item.text }}</span>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-model="form.name"
                    :rules="textValidation"
                    name="Name"
                    label="Name"
                    required
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="form.sku"
                    :rules="textValidation"
                    name="Sku"
                    label="Sku"
                    required
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="form.street_name"
                    name="Street name"
                    label="Street name"
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="form.description"
                    name="Description"
                    label="Description"
                    required
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-select
                    v-model="form.product_type"
                    :rules="normalValidation"
                    :items="[
                    {
                      text: 'Variant',
                      value: 'variant'
                    },
                    {
                      text: 'No variant',
                      value: 'no_variant'
                    }
                  ]"
                    name="Product type"
                    label="Product type"
                  ></v-select>

                  <v-select
                    v-model="form.product_family"
                    :rules="normalValidation"
                    :items="[
                    {
                      text: 'Cannabis',
                      value: 'cannabis'
                    },
                    {
                      text: 'Accessories',
                      value: 'accessories'
                    },
                    {
                      text: 'Liquor',
                      value: 'liquor'
                    },
                    {
                      text: 'Retail',
                      value: 'retail'
                    }
                  ]"
                    name="Product family"
                    label="Product family"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm12 md6 :class="$vuetify.breakpoint.width > 960 ? 'pl-3' : ''">
                  <v-textarea
                    v-model="form.usage_instructions"
                    :rules="textValidation"
                    name="Usage instruction"
                    label="Usage instruction"
                    hint="(max: 250)"
                    required
                    validate-on-blur
                  ></v-textarea>
                  <v-select
                    v-model="form.weighing_unit"
                    :rules="normalValidation"
                    :items="['g', 'ml', 'kg', 'ltr']"
                    name="Weighing unit"
                    label="Weighing unit"
                  ></v-select>
                  <v-text-field
                    v-model="form.shelf_life"
                    name="Shelf life"
                    label="Shelf life"
                    :rules="positiveNumberValidation"
                    required
                    validate-on-blur
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    type="number"
                  ></v-text-field>

                  <v-select
                    v-model="form.shelf_life_unit"
                    :items="[
                    {
                      text: 'Days',
                      value: 'days'
                    },
                    {
                      text: 'Weeks',
                      value: 'weeks'
                    },
                    {
                      text: 'Months',
                      value: 'months'
                    },
                    {
                      text: 'Years',
                      value: 'years'
                    }
                  ]"
                    name="Shelf life unit"
                    label="Shelf life unit"
                  ></v-select>

                  <v-text-field
                    :rules="positiveNumberValidation"
                    v-model="form.order"
                    name="Order"
                    label="Order"
                    required
                    validate-on-blur
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    type="number"
                  ></v-text-field>
                  <v-switch
                    v-model="form.discontinued"
                    name="Discontinued"
                    label="Discontinued"
                    color="primary"
                  ></v-switch>
                  <v-switch
                    v-model="form.featured"
                    name="Featured"
                    label="Featured"
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              @click="closeModal()"
              color="white"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
              style="text-transform: capitalize;"
            >Cancel</v-btn>
            <v-btn
              v-if="type != '' && type != 'master'"
              @click="add()"
              color="white"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0 primary' : 'ml-0 primary'"
              style="text-transform: capitalize;"
            >Create</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { BrandAPI } from '@/clients/product/brand.api'
import _ from 'lodash'
import { PosProductAPI } from '@/clients/location/pos.product.api'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
import { LocationProductAPI } from '@/clients/location/location.product.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import Helper from '@/utility/Helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      textValidation: [
        v => !!v.replace(/\s/g, '') || 'Field is required'
      ],
      positiveNumberValidation: [
        v => !!v || 'Field is required',
        v => v !== 0 || 'Must be greater than 0',
        v => /^\+?([1-9]\d*)$/.test(v) || 'Numbers only'
      ],
      type: '',
      headers: [
        { text: 'Name', value: 'thumbnail', sortable: true, width: 300 },
        { text: 'Category', value: 'category', sortable: true, width: 200 },
        { text: 'Actions', value: 'action', sortable: false, width: 150 }
      ],
      posProductHeading: [
        { text: 'Name', value: 'name', sortable: true, width: 300 },
        { text: 'POS ID', value: 'external_id', sortable: true, width: 100 },
        { text: 'GTIN', value: 'gtin', sortable: true, width: 100 },
        { text: 'Category', value: 'category', sortable: true, width: 200 },
        { text: 'Actions', value: 'action', sortable: false, width: 100 }
      ],
      posProduct: 1,
      posProductCount: 0,
      posProductPerPage: 10,
      clone_from_posProduct: false,
      clone_from_posProduct_obj: {},

      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      form: {
        brand_id: '',
        category_id: '',
        name: '',
        sku: '',
        street_name: '',
        description: '',
        usage_instructions: '',
        discontinued: false,
        product_type: '',
        weighing_unit: '',
        shelf_life: '',
        shelf_life_unit: '',
        order: '',
        featured: false,
        product_family: '',
        // weight: null,
        // price: null,
        location_id: ''
      },

      brandList: [],
      locationCategoryList: []
    }
  },
  computed: {
    selectableBrands: function () {
      return Helper.getSelectableValue(this.brandList, 'name', 'id')
    },
    selectableCategories: function () {
      return Helper.getSubcategorySelectableValue(this.locationCategoryList, 'name', 'id', 'parent_category')
    },
    masterProductWithCategoryAppended() {
      let items = []
      this.getMasterProductList.map(product => {
        let data = product
        data['category'] = ''
        items.push(data)
      })
      return items
    },
    posProductListWithCategoryAppended() {
      let items = []
      this.posProductList.map(product => {
        let data = product
        data['category'] = ''
        items.push(data)
      })
      return items
    },
    ...mapGetters({
      addModal: 'locationproduct/addPop',
      getList: 'locationproduct/list',
      // locationCategoryList: 'locationcategory/list',
      getMasterProductList: 'product/list',
      selectedLocation: 'location/selected',
      posProductList: 'location_pos_product/list'
    })
  },

  watch: {
    'type': function (str) {
      // If str is balnk clear form
      if (str === '') {
        Helper.setObjValueEmpty(this.form)
      }

      // If the data is new
      if (str === 'new') {
        // check if new is coming for global till now if yes fill in forms
        if (this.clone_from_posProduct) {
          // If clone from global till now active
          this.form.name = this.clone_from_posProduct_obj.name
          //  this.form.sku = this.clone_from_posProduct_obj.sku;
          // this.form.price = this.clone_from_posProduct_obj.price;
          this.form.category_id = parseFloat(this.clone_from_posProduct_obj.category)
        }
      }
    }
  },
  async created() {
    this.loaded = false

    // We need to fetch Brands because we need to sue here
    // brand list
    const brandData = await BrandAPI.brandList()
    this.brandList = _.sortBy(brandData.data.payload, 'name')

    const { data } = await LocationCategoryAPI.fetch(this.selectedLocation.id)
    data.payload.forEach(each => {
      if (each.parent_category === null) {
        this.locationCategoryList.push(each)
        if (each.subCategory.length > 0) {
          this.locationCategoryList = [
            ...this.locationCategoryList,
            ...each.subCategory
          ]
        }
      }
    })

    // this.locationCategoryList = locationCategoryData.data.payload

    // this.setLocationCategoryList(this.selectedLocation.id)
    // ProductApis.fetch();

    this.loaded = true
  },
  async mounted() {
    let locationId = this.selectedLocation.id
    if (locationId) {
      // this.setPosProductList(locationId)
      // PosProductAPI.fetch(locationId)
    }
    // this.closeModal()
  },
  methods: {
    /**
     * Routing to Database Selection
     */
    syncWithPos() {
      this.closeModal()
      this.$router.push({ name: 'DatabaseSelection' });
    },
    syncWithCova() {
      this.closeModal()
      this.$router.push({ name: 'DatabaseSelection' });
    },
    /**
     * Back to select option
     */
    backToAddOption() {
      this.clone_from_posProduct = false
      this.clone_from_posProduct_obj = {}
      this.type = ''
    },
    /**
     * Sync pos and qty
     */

    async syncPosPriceAndQty() {
      try {
        this.spinner(true)
        let res = await PosProductAPI.syncPosPriceAndQty(this.selectedLocation.id)
        this.spinner(false)
        if (res.status === 200) {
          LocationProductAPI.fetch(this.selectedLocation.id)
        }
        this.snackbar({
          text: res.status === 200 ? res.data.message : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
          color: res.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    },

    /**
     * Copy post product
     */
    async importPostProduct(params) {
      try {
        this.spinner(true)
        let res = await PosProductAPI.importPos(this.selectedLocation.id, params)
        this.spinner(false)
        if (res.status === 200) {
          this.snackbar({
            text: res.data.msg,
            open: true,
            color: 'success'
          })
          // now fetch location product again
          LocationProductAPI.fetch(this.selectedLocation.id)
        } else {
          this.snackbar({
            text: 'Please try again later.',
            open: true,
            color: 'error'
          })
        }
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.msg,
          open: true,
          color: 'error'
        })
      }
    },

    /**
     * Fill in from global till
     */
    async preFillPosProductData(obj) {
      // If no category selected prevent submission
      if (obj.category === '') {
        this.snackbar({
          text: 'Please select category.',
          open: true,
          color: 'error'
        })
        return false
      }
      // If gtin is blank just fill in form values
      if (obj.gtin === '') {
        this.clone_from_posProduct = true
        this.clone_from_posProduct_obj = obj
        this.type = 'new'
      } else {
        //  Check the value exist then assign that value from gitin
        this.spinner(true)
        let res = await LocationProductAPI.getByGtin(obj.gtin)
        if (res.status === 200) {
          // this.snackbar({
          //   message: 'Product found. Please wait.',
          //   modal: true,
          //   color:  'success',
          // });
          let productIds = []
          productIds.push(res.data.payload.product_id)
          let cloneRes = await LocationProductAPI.cloneFromMaster({
            product_id: productIds,
            category_id: obj.category,
            location_id: this.selectedLocation.id
          })
          this.snackbar({
            text: cloneRes.status === 200 ? cloneRes.data.msg : cloneRes.response.data.errors ? cloneRes.response.data.errors[0] : cloneRes.response.data.msg,
            open: true,
            color: cloneRes.status === 200 ? 'success' : 'error'
          })
          this.spinner(false)
        } else {
          this.spinner(false)
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        }
      }
    },

    /**
     * Add new product
     */
    async add() {
      if (this.$refs['addForm'].validate()) {
        // Hit apis
        this.form.location_id = this.selectedLocation.id
        this.spinner(true)
        try {
          let res = await LocationProductAPI.insert(this.form)
          if (res.status === 200) {
            this.closeModal()
          }
          this.snackbar({
            text:
              res.status === 200
                ? res.data.msg
                : res.response.data.errors
                ? res.response.data.errors[0]
                : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.snackbar({
            text: Array.isArray(err.response.data.errors)
              ? err.response.data.errors[0]
              : err.response.data.msg,
            open: true,
            color: 'error'
          })
        } finally {
          this.spinner(false)
        }

        // Display message alert
      }
    },
    /**
     * Add / Clone this to location product
     */
    async addFromMasterProduct(obj) {
      // If no category selected prevent submission
      if (obj.category === '') {
        this.snackbar({
          text: 'Please select category.',
          open: true,
          color: 'error'
        })
        return false
      }
      let masterPids = []
      masterPids.push(obj.id)
      this.spinner(true)
      let res = await LocationProductAPI.cloneFromMaster({
        product_id: masterPids,
        category_id: obj.category,
        location_id: this.selectedLocation.id
      })
      this.spinner(false)
      this.snackbar({
        text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
        open: true,
        color: res.status === 200 ? 'success' : 'error'
      })
      // Clear all category to blank
      if (res.status === 200) {
        this.getMasterProductList.map(product => {
          product.category = ''
        })
      }
    },

    /**
     * Close add  popup
     */
    async closeModal() {
      this.type = ''
      this.clone_from_posProduct = false
      this.clone_from_posProduct_obj = {}
      this.setAddPopup(false)
      await Helper.setObjValueEmpty(this.form)
      this.form.discontinued = false
      this.form.featured = false
    },
    ...mapActions({
      setAddPopup: 'locationproduct/setAddPop'
      // setList: 'locationproduct/setList',
      // setLocationCategoryList: 'locationcategory/setList',
      // setPosProductList: 'location_pos_product/setList'

    })
  }
}
</script>
